import { Language, ManageProjectTabs } from '^/types';

const { INFORMATION, SETTING, SHARE }: typeof ManageProjectTabs = ManageProjectTabs;

export default {
  manageProject: {
    [Language.EN_US]: 'Manage Project',
    [Language.KO_KR]: '프로젝트 관리',
  },

  overview: {
    [Language.EN_US]: 'Overview',
    [Language.KO_KR]: '개요',
  },
  title: {
    [Language.EN_US]: 'Title',
    [Language.KO_KR]: '제목',
  },
  description: {
    [Language.EN_US]: 'Description',
    [Language.KO_KR]: '설명',
  },
  projectLogo: {
    [Language.EN_US]: 'Project Logo',
    [Language.KO_KR]: '프로젝트 로고',
  },
  logoDescription: {
    [Language.EN_US]: 'Logo description',
    [Language.KO_KR]: '로고 설명',
  },
  appearance: {
    [Language.EN_US]: 'Appearance',
    [Language.KO_KR]: '디자인 설정',
  },
  spatialSettings: {
    [Language.EN_US]: 'Spatial Settings',
    [Language.KO_KR]: '공간 설정',
  },
  moreSettings: {
    [Language.EN_US]: 'More Settings',
    [Language.KO_KR]: '추가 설정',
  },
  applyGcpSettings: {
    [Language.EN_US]: 'Apply GCP Settings',
    [Language.KO_KR]: 'GCP 설정 적용',
  },
  unitSystem: {
    [Language.EN_US]: 'Unit System',
    [Language.KO_KR]: '단위 시스템',
  },
  coordinateSystem: {
    [Language.EN_US]: 'Coordinate System',
    [Language.KO_KR]: '좌표계',
  },
  tabs: {
    [INFORMATION]: {
      [Language.EN_US]: 'Information',
      [Language.KO_KR]: '정보',
    },
    [SETTING]: {
      [Language.EN_US]: 'Setting',
      [Language.KO_KR]: '설정',
    },
    [SHARE]: {
      [Language.EN_US]: 'Share',
      [Language.KO_KR]: '공유',
    },
  },
};
